import React, { useEffect } from 'react'
import { ConversionCampaignOffer, OfferMeta } from '../../../../types/conversions'
import LockedOffer from '../LockedOffer/LockedOffer'
import CreatorCommission from './CreatorCommission'
import CreatorSale from './CreatorSale'
import PlatformSale from './PlatformSale'
import OfferLayout from './OfferLayout'
import { useNavigate, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from '../../../../redux-stores/store'
import NotFound from '../../../../pages/system/NotFound'
import { fetchConversionCampaignThunk } from '../../../../redux-stores/slices/conversionCampaignSlice'
import { offerDetails } from '../MyProgress'
import { setHeader, setShowFooterNav } from '../../../../redux-stores/slices/layoutSlice'
import { defaultAppHeaderProps } from '../../../../types/layout/layoutTypes'
import { WEB_APP_URL } from '../../../../constants/constants'
import { Share } from '@capacitor/share';
import ifConfigured from '../../../../utils/hoc/ifConfigured'


const Offer: React.FC = () => {
    const { campaignId, offerId } = useParams();
    const campaign = useSelector((state: RootState) => state.conversionCampaigns.items[campaignId!]?.campaign);
    const offer = campaign?.offers.find((o) => o.uuid === offerId);
    const dispatch: AppDispatch = useDispatch();
    const referralCode = useSelector((state: RootState) => state.auth.user?.referral_code);
    const navigate = useNavigate();
    const meta = offerDetails[offer?.type as keyof typeof offerDetails];
    useEffect(() => {
        if (campaignId) {
            dispatch(fetchConversionCampaignThunk({ campaignId }))
        }
    }, [campaignId])

    useEffect(() => {
        dispatch(setHeader(null))
        dispatch(setShowFooterNav(false))

        return () => {
            dispatch(setHeader(defaultAppHeaderProps))
            dispatch(setShowFooterNav(true))
        }
    }, [])


    const handleInviteFriends = async () => {
        const url = `${WEB_APP_URL}/cc/${campaignId}?referrer=${referralCode}`;
        try {
            await Share.share({
                title: 'Check out this new campaign on Influns!',
                text: `Hey! I don't usually send these, but this one felt worth sharing 👀 Something big is happening on Influns right now 🚀
I'm part of this new campaign and it's quite different— instead of competing, creators are actually helping each other grow.
You earn from Amazon like usual, but if the community hits the target, everyone unlocks a bonus. So more creators = more reach = more earnings for all.
You should definitely be in this 👇`,
                url: url,
                dialogTitle: 'Share with friends'
            });
        } catch (error) {
            console.error(error);
        }
    }

    if (!offer) {
        return <NotFound />
    }

    return (
        <>
            <OfferLayout onBackClick={() => navigate(`/conversion/${campaignId}`)} meta={meta}>
                {
                    offer.type === 'creator_commission' && <CreatorCommission offer={offer} meta={meta} currency={campaign?.currency} />
                }
                {
                    offer.type === 'creator_sale' && <CreatorSale offer={offer} meta={meta} currency={campaign?.currency} />
                }
                {
                    offer.type === 'platform_sale' && <PlatformSale offer={offer} meta={meta} currency={campaign?.currency} />
                }
            </OfferLayout>
            {
                offer.type === 'platform_sale' && (
                    <div className='sticky-footer'>
                        <button className='btn btn-primary w-100' onClick={handleInviteFriends}>Invite Friends</button>
                    </div>
                )
            }
        </>

    )
}

export default ifConfigured(Offer, 'influencer_conversion_campaign', '/')